import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { Button, Label, Loader, TableCell, TableRow } from "semantic-ui-react";
import { EligibilityRadio } from "../EligibilityRadio";
import { EligibilityCriterion, EligibilityLevel } from "@/services/bedrock";

interface OwnProps {
  level: EligibilityLevel;
  currentRule: EligibilityCriterion | undefined;
  tags: string[];
  onIncludeFlagChanged: (flag: boolean) => void;
  onUpdateClicked: () => void;
  loading?: boolean;
  readOnly?: boolean;
}

type Props = OwnProps;

const EligibilityRuleFC: React.FC<Props> = ({
  level,
  currentRule,
  tags,
  onUpdateClicked,
  onIncludeFlagChanged,
  loading,
  readOnly,
}) => {
  const [included, setIncluded] = useState(!!currentRule ? currentRule.isInclude : true);

  useEffect(() => {
    setIncluded(!!currentRule ? currentRule.isInclude : true);
  }, [currentRule?.isInclude]);

  const label = useMemo(() => {
    switch (level) {
      case "STATE":
        return "States";
      case "REGION":
        return "Regions";
      case "PLAYER_ID":
        return "Specific Players";
      case "BRANCH":
        return "Branches";
    }
  }, [level]);

  return (
    <>
      <TableRow>
        <TableCell>{label}</TableCell>
        <TableCell>
          <EligibilityRadio
            name={`rule-radio-${level}`}
            included={included}
            onUpdate={f => {
              setIncluded(f);
              onIncludeFlagChanged(f);
            }}
          />
        </TableCell>
        <TableCell>
          {loading && <Loader inline active />}
          {!loading && (
            <div className={"ruleTags"}>
              {tags.length > 0 &&
                tags.map((tag, index) => {
                  return <Label key={`tag-${index}`}>{tag}</Label>;
                })}
              {!readOnly && (
                <Button type="button" basic size={"tiny"} onClick={onUpdateClicked} className={"ruleButton"}>
                  {tags.length == 0 ? "Add" : "Edit"} {label}
                </Button>
              )}
            </div>
          )}
        </TableCell>
      </TableRow>
    </>
  );
};

export const EligibilityRule = EligibilityRuleFC;
